module.exports = __webpack_public_path__ + "img/999.3476ef16.gif";